import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MatSelect, MatSnackBar } from '@angular/material';
import { DashboardDriversBlockComponent } from '../dashboard-drivers-block/dashboard-drivers-block.component';
import { Subject } from 'rxjs/Subject';
import { switchMap } from 'rxjs/operators';
import { ErrorMessageComponent, EventMessageComponent } from '../../shared/index';
import { DriverService } from '../../shared/services/driver.service';

@Component({
  selector: 'app-dashboard-drivers',
  templateUrl: './dashboard-drivers.component.html',
  styleUrls: ['./dashboard-drivers.component.scss']
})
export class DashboardDriversComponent implements OnInit, OnDestroy {
  @Output() ClosePopUp = new EventEmitter<boolean>();
  @Input() taxiServices = null;
  @ViewChild('serviceTrack', { read: MatSelect }) serviceTrack: MatSelect;

  items: Array<any>;
  search: string = null;
  service = null;
  reasons;
  dialogRef: MatDialogRef<DashboardDriversBlockComponent>;
  opened = false;
  private searchTerms = new Subject<string>();
  searchString = '';

  constructor(
    private dialog: MatDialog,
    private viewContainerRef: ViewContainerRef,
    private snackBar: MatSnackBar,
    private driver: DriverService
  ) {}

  ngOnInit() {
    if (this.taxiServices !== null) {
      this.service = this.taxiServices[0].id;
    }

    this.searchTerms
      .pipe(
        switchMap(data => {
          return this.driver.getDrivers({
            service: this.service,
            query: data
          });
        })
      )
      .subscribe({
        next: obj => {
          this.items = obj['data'];
        },
        error: err => {
          console.log('err', err);
        }
      });
  }

  close() {
    this.ClosePopUp.emit(false);
  }

  searchDriver(term: string) {
    if (!term) {
      return;
    }
    this.searchString = term;
    this.searchTerms.next(term);
  }

  openDriverBlock(obj) {
    if (!obj.accounts[0].is_blocked) {
      let config = <MatDialogConfig>{
        viewContainerRef: this.viewContainerRef,
        position: {
          top: '5%'
        },
        data: {
          id: obj.id,
          service: this.service
        },
        disableClose: true
      };
      this.opened = true;
      this.dialogRef = this.dialog.open(DashboardDriversBlockComponent, config);
      this.dialogRef.afterClosed().subscribe(data => {
        if (data == 'true') {
          this.handleServiceEvent('Водитель заблокирован успешно');
          this.ClosePopUp.emit(false);
        }
        this.dialogRef = null;
        this.opened = false;
      });
    }
  }

  snackMsg(driver) {
    this.handleServiceError(driver.account.callsign, 'DRIVER_BLOCKED');
  }

  ngOnDestroy(): void {
    if (this.searchTerms) {
      this.searchTerms.unsubscribe();
    }
  }

  selectionChange() {
    this.searchDriver(this.searchString);
  }

  private handleServiceEvent(msg) {
    this.snackBar.openFromComponent(EventMessageComponent, {
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      data: {
        message: msg
      }
    });
  }

  private handleServiceError(op: string, err: any) {
    this.snackBar.openFromComponent(ErrorMessageComponent, {
      duration: 6000,
      extraClasses: ['error-msg'],
      verticalPosition: 'top',
      horizontalPosition: 'center',
      data: {
        op: op,
        err: err
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard-drivers/dashboard-drivers.component.ts